module.exports = __webpack_public_path__ + "img/2_3_m.08ead546.jpg";